import React, { useContext, useEffect, useLayoutEffect, useState } from 'react'
import { useLocation } from 'react-router';
import DatePicker from 'react-datepicker';
import './style.css'
import { toast } from 'react-toastify';
import { getFormattedDate } from '../../../common/date';
import LenderUgroService from '../../../services/lender';

import { Context } from '../../../config/store';
import { downloadFile } from '../../../common/download';
import ReactTooltip from 'react-tooltip';

export default function QueryMis() {
  const location = useLocation()
  const { state } = useContext(Context);

  const [title, setTitle] = useState('')
  const [tableLoader, setTableLoader] = useState(false)
  const [submitLoader, setSubmitLoader] = useState(false)
  const [lenderLoader, setLenderLoader] = useState(true)
  const [downloadFromDate, setDownloadFromDate] = useState('')
  const [downloadToDate, setDownloadToDate] = useState('')
  const [endPoint, setEndPoint] = useState('')
  const [lenderDataList, setLenderDataList] = useState([])
  const [ElegibleLender, setElegibleLender] = useState('')
  const [permission, setPermission] = useState('')
  const [assignDatefrom, setAssignDatefrom] = useState('')
  const [assignDateto, setAssignDateto] = useState('')
  const [lenderDatefrom, setLenderDatefrom] = useState('')
  const [lenderDateto, setLenderDateto] = useState('')
  const [assignlender, setassignlender] = React.useState('');
  const [programName, setProgramName] = useState('')
  const [showError, setShowError] = useState(false);

  let heading = location.pathname.split('/')[2]

  useEffect(async () => {
    setTitle(heading)
    setDownloadFromDate('')
    setDownloadToDate('')
    setElegibleLender('')
    setAssignDatefrom('')
    setAssignDateto('')
    setShowError(false)
    if (heading === 'lender') {
      setTitle(`${heading.charAt(0).toUpperCase() + heading.substring(1)} Mis Report`)
      setPermission('submit-lender-mis-report')
      setEndPoint('lender-mis')
      await getDownloadsHistory('lender-mis/list')
    }
  }, [heading])

  const getDownloadsHistory = async (endPoint) => {
    let response = null;
    response = await LenderUgroService.getDownloadsHistory({
      type: 'lender',
      endPoint
    });
    if (heading === 'lender') {
      setLenderDataList(response?.data?.data?.lender_mis_reports)
      setLenderLoader(false)
    }
  }

  const handleLenderMisReport = async () => {
    if (!programName) {
      return toast.error("Please select Program Name");
    }
    if ((lenderDatefrom && !lenderDateto) || (!lenderDatefrom && lenderDateto)) {
      return toast.error("Please select from date and to date")
    }

    if (lenderDatefrom <= lenderDateto) {
      let payloadData = {
        prod_cat: programName,  //(required)
        assigned_date_from: lenderDatefrom ? getFormattedDate(lenderDatefrom, 'dd/MM/yyyy') : '',
        assigned_date_to: lenderDateto ? getFormattedDate(lenderDateto, 'dd/MM/yyyy') : ''
      }
      let response = null;
      let toastId = null;
      try {
        setSubmitLoader(true)
        response = await LenderUgroService.downloadMisReportNew({
          type: state.userType,
          dataExport: 1,
          responseType: "blob",
          endPoint,
          payloadData
        });
        toastId = toast.success(response?.data?.messages?.success?.others[0])
        let toastInfo = response?.data?.messages?.error?.others.join()
        if (toastInfo.length > 0) {
          toast.info(toastInfo)
        }
        setProgramName('')
        setLenderDatefrom('')
        setLenderDateto('')
        setSubmitLoader(false)
        setTimeout(async () => {
          await getDownloadsHistory('lender-mis/list')
        }, 2000);
      } catch (error) {
        toast.dismiss(toastId)
        toast.error(error.message)
        setTableLoader(false)
        setSubmitLoader(false)
      }
    } else {
      toast.error("From date must be less than To date")
      return;
    }
  }

  const handleReportDownload = async (fileName, fileId) => { 
    let response = null;
    let toastId = toast.warning("Download started, Please wait...")
    try {
      response = await LenderUgroService.downloadFileById({
        type: state.userType,
        fileId,
        responseType: 'blob'
      });
      toast.dismiss(toastId)
      downloadFile(response?.data, fileName)
    } catch (error) {
      toast.dismiss(toastId)
      toast.error(error.message)
    }
  }

  const handleRefresh = async () => {
    setTableLoader(true)
    if (heading === 'lender') {
      await getDownloadsHistory('lender-mis/list')
      setTableLoader(false)
    }
  }

  const checkHasPermission = (checkPermission) => {
    if (state.is_super_admin === 1) return true;
    const permission = state.permission.find(
      (permission) => permission === checkPermission
    );

    if (permission) return true;
    else return false;
  };
  const resetFilter = () => {
    setDownloadFromDate('')
    setDownloadToDate('')
    setElegibleLender('')
    setAssignDatefrom('')
    setAssignDateto('')
    setassignlender('')
    setShowError(false)
    setProgramName('')
    setLenderDatefrom('')
    setLenderDateto('')
  }

  return (
    <div class="portfolio-dashboard">
      <div class="chart-card h-100">
        <div className='d-flex'>
          <h3 className='topTitle'>{title}</h3>
        </div>
        {state?.user?.cl_lender_id == 21 ?
        <div className='form-group'>
          <div className='d-flex align-items-end datepicker'>
            {heading === 'lender' && checkHasPermission(permission) &&
              <>
                <div className='datepicker'>
                  <label className='datepickerLabel'>Case Assign Date from</label>
                  <div>
                    <DatePicker
                      selected={lenderDatefrom}
                      portalId='datepickerportal'
                      showMonthDropdown
                      yearDropdownItemNumber={100}
                      scrollableYearDropdown={true}
                      showYearDropdown
                      className='form-control height25'
                      dateFormat='dd/MM/yyyy'
                      onChange={(selectedDate) =>
                        setLenderDatefrom(selectedDate)
                      } //only when value has changed
                    />
                  </div>
                </div>
                <div className="datepicker">
                  <label className='datepickerLabel'>Case Assign Date to</label>
                  <div>
                    <DatePicker
                      selected={lenderDateto}
                      portalId='datepickerportal'
                      yearDropdownItemNumber={100}
                      scrollableYearDropdown={true}
                      showMonthDropdown
                      className='form-control height25'
                      dateFormat='dd/MM/yyyy'
                      onChange={(selectedDate) =>
                        setLenderDateto(selectedDate)
                      } //only when value has changed
                    />
                  </div>
                </div>
                <div className="datepicker">
                  <label className='datepickerLabel'>Program Name <tt>*</tt></label>
                  <div>
                    <select className='form-control height25'
                      onChange={(e) => {
                        setProgramName(e.target.value);
                      }}
                      value={programName}>
                      <option >{'Select Program'}</option>
                      <option value={'2'}>{'Secured'}</option>
                      <option value={'3'}>{'Unsecured'}</option>
                      <option value={'5'}>{'Secured - Plant & Machinery'}</option>
                      <option value={'6'}>{'Secured - GRO Micro'}</option>
                      <option value={'7'}>{'Unsecured - GRO Micro'}</option>
                    </select>
                  </div>
                </div>
              </>
            }
          </div>
          {(showError && heading === 'colending') &&
            <p className='ml-1 mt-0 mb-0 text-danger'>
              Please select lender
            </p>}
          {checkHasPermission(permission) && <div>
            <div className='row'>
              <div className='col-md-12 d-flex p-2'>
                {/* {<br></br>} */}
                <button
                  className='btn btn-custom submitBtn m-1'
                  disabled={submitLoader}
                  onClick={() => {
                    if (heading === 'lender') {
                      handleLenderMisReport();
                    } else {
                      // handleSubmit();
                    }
                  }}
                  style={{ cursor: 'pointer' }}
                >
                  {submitLoader ? <div className="loader"></div> : 'Search'}
                </button>
                <button
                  onClick={resetFilter}
                  type='button'
                  className='btn btn-custom submitBtn m-1'
                >
                  Reset All
                </button>
              </div>
            </div>
          </div>}
          <div className="row justify-content-between m-1 mb-2 align-items-center">
            <h3 className='DownloadTitle mb-0'>Downloads History</h3>
            <button
              className='btn btn-custom submitBtn'
              onClick={() => { handleRefresh() }}
              disabled={tableLoader}
              style={{ cursor: 'pointer' }}
            >
              {tableLoader ? <div className="loader"></div> : <span><i class="fa fa-refresh mr-1" aria-hidden="true"></i> Refresh </span>}
            </button>
          </div>
          <div className={heading != 'colending' ? 'misReports' : 'misColending'}>
            <table className="table" style={{ border: 1, borderColor: '#dee2e6', borderStyle: 'solid', textAlign: 'center' }}>
              <thead className="thead-light">
                <tr>
                  <th scope="col" style={{ width: "10%" }}>S No.</th>
                  {(heading == 'lender') && <th scope="col" style={{ width: "150px" }}>Case Assign Date from</th>}
                  {(heading == 'lender') && <th scope="col" style={{ width: "150px" }}>Case Assign Date To</th>}
                  <th scope="col" style={{ width: "150px" }}>Created at</th>
                  <th scope="col" style={heading == 'colending' ? { width: "350px" } : {}}>File Name</th>
                  <th scope="col" style={{ width: "130px" }}>Created by</th>
                  <th scope="col" style={{ width: "130px" }}>Action</th>
                </tr>
              </thead>
              <tbody>
                {heading === 'lender' ?
                  lenderLoader ?
                    <div className='MisLoaderContainer'>
                      <div className="loader" style={{ margin: "10% auto auto" }}></div>
                    </div>
                    :
                    lenderDataList?.map((item, index) => {
                      let parsedData = JSON.parse(item?.report_request)
                      let downloadDate = getFormattedDate(new Date(item?.created_at))
                      return (
                        <tr key={item?.report_id}>
                          <td>{index + 1}</td>
                          <td>{parsedData?.assigned_date_from}</td>
                          <td>{parsedData?.assigned_date_to}</td>
                          <td>{downloadDate}</td>
                          <td>{item?.file?.file_name}</td>
                          <td>{item?.user?.full_name}</td>
                          <td>
                            <ReactTooltip id='download-document'>Download Document</ReactTooltip>
                            <i class="fa fa-cloud-download fa-lg" onClick={() => { handleReportDownload(item?.file?.file_name, item?.file?.file_id) }}
                              style={{ color: '#4A4E88', cursor: 'pointer' }} data-tip
                              data-for='download-document' ></i>
                            {/* <button
                              className='btn btn-custom submitBtn'
                            >
                              Download
                            </button> */}
                          </td>
                        </tr>
                      )
                    }) : null}
              </tbody>
            </table>
          </div>
        </div>
        : <div style={{'height': '25px', 'font-size': '15px', 'margin-top': '30px', 'text-align': 'center'}}>This feature is not available for current Lender</div>
        }
      </div>
    </div>
  )
}
